import { useLibraryPostsGateway } from './LibraryPostsGatewayProvider';
import { getCommunityPostV2QueryOptions } from '../api/queryOptions';
import type { LibraryPostParams } from '../model/types';

import { useUserScopedQuery } from '@/hooks/useUserScopedQuery';

/** One post, highlighted for `q` when it was opened from a search. */
export function useLibraryPost(
  params: LibraryPostParams,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useUserScopedQuery(getCommunityPostV2QueryOptions, [params, useLibraryPostsGateway()], {
    enabled,
  });
}
